import { type MCPServerInfo } from '../../types';

const LinearServer: MCPServerInfo = {
  serverId: 'LINEAR',
  name: 'Linear',
  slug: 'linear',
  description: 'Linear MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.linear.app/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default LinearServer;
